<template>
  <div>
    <card class="w-100" v-if="$store.state.account.roleCode === 'ADMIN'">
      <el-row :gutter="10">
        <form @submit.prevent="search(1)">
          <el-col :span="2">
            <div class="form-group">
              <label>연도선택</label>
              <el-select v-model="searchParam.searchYear" placeholder="검색조건을 선택하세요." @change="changeCompany">
                <el-option
                  v-for="item in yearList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="form-group">
              <label>계약문서 상태 선택</label>
              <el-select v-model="searchParam.searchStatus" placeholder="검색조건을 선택하세요." @change="changeCompany">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="form-group">
              <label>RMS 담당자</label>
              <el-select v-model="searchParam.searchRmsDamdang" placeholder="담당선택" @change="changeCompany">
                <el-option value="" label="전체"></el-option>
                <el-option
                  v-for="item in $store.state.rmsDamdang.items"
                  :key="item.id"
                  :value="item.id"
                  :label="item.damdangName">
                </el-option>
              </el-select>
            </div>
          </el-col>

          <search-company v-model="searchParam.searchCompanySeq"  :keyword-span="2" :company-span="6" @selected="changeCompany"></search-company>  

          <el-col :span="2">
            <div class="form-group">
              <label>페이지당 리스트수</label>
              <el-select v-model="perPage">
                <el-option
                  key="10"
                  value="10"
                />
                <el-option
                  key="20"
                  value="20"
                />
                <el-option
                  key="30"
                  value="30"
                />
                <el-option
                  key="50"
                  value="50"
                />
                <el-option
                  key="100"
                  value="100"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="mt-4">
              <el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>
              <el-button type="primary" @click="resetPage" icon="el-icon-refresh">초기화</el-button>
            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <el-row :gutter="10">
    
      <el-col :span="item.size" v-for="item in $store.state.modusign.statusInfo" :key="item.meta">
        <card class="cur-pointer" @click.native="searchParam.searchStatus = item.status; changeCompany()">
            <el-col :span="14"><h6 :class="item.color">{{ item.text }}</h6></el-col>
            <el-col :span="10" class="text-right"><span class="fs-5">{{ item.value | numeral }} </span></el-col>
        </card>
      </el-col>
      <el-col :span="4" v-if="$store.state.account.roleCode === 'ADMIN'" >
        <card style="background-color: #0e2f5c;" class="text-center fs-5 cur-pointer text-white" @click.native="showContractModal()">계약시작</card>
      </el-col>
      <el-col :span="4" v-if="$store.state.account.roleCode !== 'ADMIN'" >
        <card style="background-color: #0e2f5c;" class="text-center fs-5 cur-pointer text-white" @click.native="search(1)">새로고침</card>
      </el-col>

    </el-row>

    <card class="w-100">
      <el-col :span="24" class="mt-2">
        <aw-table class="table-striped"
                  :fixed-body-header="true"
                  drag-scroll-dir="x"
                  :border="true"
                  :data="$store.state.modusign.contracts"
                  ref="contractsTable"
                  :header-cell-style="tableRowStyle">
          <el-table-column v-if="$store.state.account.roleCode === 'ADMIN'" 
            fixed
            sortable
            width="250"
            prop="companyName"
            label="업체명">
          </el-table-column>
          <el-table-column 
            fixed
            sortable
            prop="title"
            label="계약서명">
          </el-table-column>
          <el-table-column
            width="140"
            sortable
            prop="rmsDamdang"
            label="RMS 담당자">
          </el-table-column>
          <el-table-column
            width="300"
            label="참여자">
            <template slot-scope="props">
              <p v-for="item in props.row.participants">{{ item.name }} ( {{ item.signingMethod.value }} )
              <i v-if="item.signed" class="el-icon-check text-success fs18"></i>
              <i v-if="!item.signed" class="el-icon-close text-danger fs18"></i>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="status"
            width="120"
            label="상태">
            <template slot-scope="props">
              <p :class="props.row.status | statusColor">{{ props.row.status | modusignStatus }}</p>
              <p v-if="props.row.status === 'ABORTED'" class="text-danger">
                {{ props.row.abort.type | modusignAbortStatus }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="createdAt"
            width="150"
            label="업로드일">
            <template slot-scope="props">
              {{ props.row.createdAt | moment('YYYY-MM-DD HH:mm')}}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            width="150"
            prop="updatedAt"
            label="서명 완료일">
            <template slot-scope="props">
              <span v-if="props.row.status === 'COMPLETED'">{{ props.row.updatedAt | moment('YYYY-MM-DD HH:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            width="120"
            align="cneter"
            label="조회 / 다운로드">
            <template slot-scope="props">
              <el-button size="small" title="조회"  icon="el-icon-search" @click="embeddedView(props.row.id)"></el-button>
              <el-button size="small" title="다운로드" type="info" icon="el-icon-paperclip" @click="download(props.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column
          fixed="right"
            width="65"
            v-if="$store.state.account.roleCode === 'ADMIN' || $store.state.modusign.contractDownload"
            label="수정">
            <template slot-scope="props">
              <el-button size="small" title="수정" type="primary" icon="el-icon-edit" @click="editDocInfo(props.row)"></el-button>
            </template>
          </el-table-column>

        </aw-table>
      </el-col>
      <el-col :span="24">
        <p-pagination class="pull-right mt-3"
                      v-on:input="search"
                      v-model="pagination.currentPage"
                      :per-page="parseInt(pagination.perPage)"
                      :total="$store.state.modusign.total">
        </p-pagination>
      </el-col>

    </card>
    <el-row :gutter="10" v-if="$store.state.account.roleCode === 'ADMIN'">
        <el-col :span="24">
            <div class="text-right">
              <el-button type="primary" @click="rmsDamdangRegist" icon="el-icon-user">RMS 담당자 등록</el-button>
            </div>
        </el-col>
     </el-row>


  </div>
</template>

<script>
    import Vue from 'vue';
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    // import { Modal } from 'src/components/UIComponents'
    import { mapState } from 'vuex';
    import ContractModal from './ContractModal.vue'
    import RmsDamdangModal from '@/components/Pages/Views/Common/RmsDamdangModal.vue'
    import SearchCompany from '@/components/Pages/Views/Common/SearchCompany.vue'
    import { cteateDocWithTemplate, cteateDocWithUpload, updateMetadataAPI } from './createModusign'
    import AwTable from '@/components/UIComponents/Table/AwTable.vue'



    // Vue.use(Table)
    // Vue.use(TableColumn)
    // Vue.use(Select)
    // Vue.use(Checkbox)
    // Vue.use(Button)
    // Vue.use(Row)
    // Vue.use(Col)
    // Vue.use(Input)
    // Vue.use(Form)
    // Vue.use(FormItem)
    // Vue.use(Option)
    // Vue.use(Upload)
    // Vue.use(Radio)
    // Vue.use(CheckboxGroup)
    // Vue.use(RadioGroup)
    // Vue.component('search-company',SearchCompany)

    let vm
    
    export default {
        name: "AdvertiserContract",
        components: {
            SearchCompany,
            PPagination,
            AwTable,
        },
        destroyed() {
          // window.removeEventListener('modusign.end')
          delete window.onModusignEnd
        },
        created: function () {
            vm = this
            if(this.$route.params.pagination !== undefined) this.pagination = this.$route.params.pagination;
            const year = parseInt(this.$moment().format('YYYY'))
            for(let i=year; i>2021; i--) {
              this.yearList.push({text:i,value:i})
            }
            this.$store.dispatch('common/setMenuTitle', "전자 계약");
          
            if(this.$store.state.account.roleCode === 'ADMIN') {
                // this.getAdvertisers();
            } else if (this.$store.state.account.roleCode === 'ADVERTISER') {
                this.searchParam.searchCompanySeq = this.$store.state.account.companySeq;
            }
            //alert(this.$store.state.account.companySeq)
            this.search(1);
            this.getRmsDamdangList()

            // 새창에서 모두싸인 계약서 작성이 완료되면 발생하는 이벤트
            // window.addEventListener('modusign.end',(event)=>this.onModusignEnd(event))
            window.onModusignEnd = this.onModusignEnd


        },
        updated: function () {
            this.$refs.contractsTable.doLayout();
        },
        computed: {
            perPage: {
              get() {
                return this.pagination.perPage
              },
              set(value) {
                window.localStorage.setItem('contract.perPage', value)
                this.pagination.perPage = value
              }
            }
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            // 화면 초기화
            resetPage() {
              this.searchParam.searchCompanySeq = '';
              this.searchParam.searchYear = '';
              this.searchCompanyName = '';
              this.searchParam.searchStatus = '';
              this.searchParam.searchRmsDamdang = '';
              this.search(1);
            },
            search( page ) {
              if(page) {
                this.searchParam.page = page
                this.pagination.currentPage = page;
              }
              this.searchParam.rows = this.pagination.perPage
              this.$store.dispatch('modusign/findAll', this.searchParam)
            },
            changeCompany(value) {
                this.search(1);
            },
            download( row) {
                const filename = row.title+'.pdf'
                const url = row.file.downloadUrl
                location.href = '/api/advertiser/modusign/download?authorization=' + $cookies.get('id_token') +'&url=' + encodeURIComponent(url) + '&filename=' + encodeURIComponent(filename)
            },
            embeddedView( docId ) {
              this.$store.dispatch('modusign/embeddedView', docId )
              .then(url => window.open(url))
            },
            // 계약서 수정 모달
            editDocInfo( data ) {
              const metaData = { id : data.id }
              data.metadatas.forEach(item=>{
                metaData[item.key] = item.value
              })
              this.$modal.show(
                ContractModal,
                { handler: this.updateMetadatas, mode: 'update', metaData: metaData },
                { draggable: false, width:'780px', height: 'auto', scrollable: true, adaptive: true },
                { }
              )

            },
            // 계약서 meta 수정 API
            updateMetadatas( data ) {
              console.log(data)
              updateMetadataAPI( data )
              .then(() => {
                alert('수정 되었습니다.')
                this.search()
              })
            },
            // 계약서 작성 모달 
            showContractModal() {
              this.$modal.show(
                ContractModal,
                { handler: this.createContract, mode: 'insert' },
                { width:'780px', height: 'auto', scrollable: true },
                { }
              )
              .render.then(instance => {
                this.modalInstance = instance
              })

            },
            // 계약서 작성 API 호출
            createContract( data ) {
                let promise
                const width = screen.width*0.7, height = screen.height*0.8, left = (screen.width - width)/2, top = (screen.height - height)/2;
                if(data.docKind === 'T') {
                  promise = cteateDocWithTemplate( data )
                } else {
                  promise = cteateDocWithUpload( data )
                }  

                promise.then((response) => {
                  if(response.data.embeddedUrl) {
                    
                    //this.modalInstance.close()
                    //if(confirm('MODUSIGN 입력 화면으로 이동하시겠습니까?\n입력을 완료 후 목록을 다시 검색하면 문서를 확인하실 수 있습니다.')) {
                      const win = window.open( response.data.embeddedUrl, '', `width=${width},height=${height},left=${left},top=${top}` )
                      
                      // window.open( 'http://127.0.0.1:8081/#/modusign/embedded-drafts', '', `width=${width},height=${height},left=${left},top=${top}` )
                      /*
                      setTimeout(()=> {
                        //win.onbeforeunload = () => { vm.$modal.hideAll() }
                        win.addEventListener('beforeunload', () => vm.$modal.hideAll() )
                      },1000)  
                      */
                      let closeCheck = setInterval(function () {
                          (win == null || win.closed) && (clearInterval(closeCheck), (() => {
                            vm.$modal.hideAll() 
                          })());    
                      }, 500);


                    //}  
                    return
                  }
                  alert('MODUSIGN API서버와 통신에 문제가 있습니다. 관리자에게 문의해 주세요.')

                })


            },
            // 새창에서 모두사인 작업이 끝나면 호출 
            onModusignEnd( eventType ) {

              let msg;
              if(eventType === 'document_started') {
                msg = '계약서 전송이 완료되었습니다'
              }
              // 모달을 닫는다.
              alert(msg+'\n리스트를 새로 불러옵니다.')
              //this.modalInstance.close()
              this.$modal.hideAll()

              this.resetPage()

            },
            // RMS 담당자 등록
            rmsDamdangRegist() {
              this.$modal.show(
                RmsDamdangModal,
                { },
                { width:'780px' },
                { }
              )              
              
            },
            getRmsDamdangList() {
              this.$store.dispatch('rmsDamdang/getList')
            }
        },
        data() {
            return {
                keywordOptions: [
                    {label: '전체',value: ''},
                    {label: '가',value: '가'},
                    {label: '나',value: '나'},
                    {label: '다',value: '다'},
                    {label: '라',value: '라'},
                    {label: '마',value: '마'},
                    {label: '바',value: '바'},
                    {label: '사',value: '사'},
                    {label: '아',value: '아'},
                    {label: '자',value: '자'},
                    {label: '차',value: '차'},
                    {label: '카',value: '카'},
                    {label: '타',value: '타'},
                    {label: '파',value: '파'},
                    {label: '하',value: '하'},
                    {label: 'A-z',value: 'a'}
                  ],
                searchParam: {
                    searchYear: '',
                    searchStatus: '',
                    searchCompanySeq: '',
                    searchRmsDamdang: '',
                    page: 1,
                    rows: 10
                },
                searchCompanyName: '',
                pagination: {
                  perPage: window.localStorage.getItem('contract.perPage') || 10,
                  currentPage: 1,
                  perPageOptions: [5, 10, 25, 50],
                },
                yearList: [{text:'전체', value:''}],
                statusList: [
                  {text:'전체', value:''},
                  {text:'서명 완료', value:'COMPLETED'},
                  {text:'내서명 필요', value:'NEED_SIGNING'},
                  {text:'광고주 서명 대기중', value:'WAIT_FOR_SIGNING'},
                  //{text:'서명 후 취소', value:'SIGNING_CANCELLED'},
                  {text:'서명 취소', value:'REQUEST_CANCELLED'},
                  //{text:'거절됨', value:'REJECTED'},
                ]

            }
        }
    }
</script>

<style scoped>
  .el-form-item {
    margin-bottom: 0px;
  }
</style>

<style>

  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: #212529 !important;
  }
  .bg-purple-light {
    background: #f8f9fc;
  }
</style>
